import * as Scrivito from "scrivito";

export const BasePageClass = Scrivito.createObjClass({});
